#import "@/apollo/fragments/Client.gql"

mutation AddClient($name: String!) {
    addClient(name: $name) {
        ...Client
    }
}
